module.exports = "/_next/static/images/iq-66216bd0ac029a43ca2425be1d060635.svg";